import React from "react";
import { ArrowRight } from "lucide-react";
import CommonButton from "../../ui/inputs/CommonButton.js";
import { Box } from "@mui/material";

const HeroActions = ({ history }) => {
  return (
      <Box
        className="home-hero-actions"
        sx={{
          display: "flex",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
      <CommonButton
        variant="contained"
        size="hero"
        onClick={() => (window.location.href = "#game-arena")}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        Play Now
        <ArrowRight size={18} strokeWidth={2} />
      </CommonButton>

      <CommonButton
        variant="outlined"
        size="hero"
        onClick={() => history.push("/all-lotteries")}
        sx={{
          color: "rgba(0, 0, 0, 0.85)",
          borderColor: "rgba(0, 0, 0, 0.3)",
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.1)",
            borderColor: "rgba(0, 0, 0, 0.6)",
          },
        }}
      >
        Browse all games
      </CommonButton>
    </Box>
  );
};

export default HeroActions;